import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { CalendarClock } from "lucide-react";

const fmtDe = (s) => new Date(`${s}T00:00:00`).toLocaleDateString("de-DE", { weekday: "short", day: "2-digit", month: "2-digit" });

export function MonteurFreeTermine({ today }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/kalender-termine").then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, []);
  const open = items.filter((t) => (t.datum_ende || t.datum) >= today);
  if (!open.length) return null;
  return (
    <section data-testid="section-free-termine">
      <div className="flex items-center gap-2 mb-3">
        <CalendarClock className="h-4 w-4 text-sky-500" />
        <h2 className="font-heading text-lg font-bold tracking-tight">Sonstige Termine</h2>
        <span className="ml-auto text-[11px] text-muted-foreground">{open.length}</span>
      </div>
      <div className="space-y-2">
        {open.map((t) => {
          const isToday = t.datum <= today && (t.datum_ende || t.datum) >= today;
          return (
            <Card key={t.id} className={isToday ? "border-sky-400" : "border-border"} data-testid={`free-termin-${t.id}`}>
              <CardContent className="p-4 space-y-1">
                <div className="flex items-start justify-between gap-2">
                  <div className="font-semibold text-sm">{t.titel}</div>
                  <span className={`text-[11px] shrink-0 ${isToday ? "text-sky-600 font-semibold" : "text-muted-foreground"}`}>
                    {isToday ? "Heute" : fmtDe(t.datum)}{t.datum_ende ? ` – ${fmtDe(t.datum_ende)}` : ""}{t.uhrzeit_von ? ` · ${t.uhrzeit_von}${t.uhrzeit_bis ? `–${t.uhrzeit_bis}` : ""}` : ""}
                  </span>
                </div>
                {t.notiz && <div className="text-xs text-muted-foreground whitespace-pre-line">{t.notiz}</div>}
              </CardContent>
            </Card>
          );
        })}
      </div>
    </section>
  );
}
